export const NEW_APP_CONTENT_AVAILABLE = 'NEW_APP_CONTENT_AVAILABLE';
export const HIDE_NEW_CONTENT_DRAWER = 'HIDE_NEW_CONTENT_DRAWER';

export const appUpdateReducer = (
  state = {
    newAppContentAvailable: false,
    hideNewContentDrawer: false,
  },
  action
) => {
  switch (action.type) {
    case NEW_APP_CONTENT_AVAILABLE: {
      return {...state, newAppContentAvailable: true};
    }
    case HIDE_NEW_CONTENT_DRAWER: {
      return {...state, hideNewContentDrawer: true};
    }
    default:
      return state;
  }
};

export default appUpdateReducer;



// WEBPACK FOOTER //
// ./src/reducers/appUpdate.js